module.exports = __webpack_public_path__ + "img/1.802d12eb.png";